import { type Chain, defineChain as defineViemChain } from 'viem'

// Define Unichain config
const unichainConfig = {
    id: 130,
    name: 'Unichain',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://unichain-mainnet.g.alchemy.com/v2/yHZvr09DRycjGM-t-j5hkUvOgfgx8gbt'],
            webSocket: [],
        },
        public: {
            http: ['https://unichain-mainnet.g.alchemy.com/v2/yHZvr09DRycjGM-t-j5hkUvOgfgx8gbt'],
            webSocket: [],
        },
    },
    blockExplorers: {
        default: { name: 'Uniscan', url: 'https://uniscan.xyz' },
    },
} as const satisfies Chain

const wagmiUnichain = defineViemChain(unichainConfig)

// Define MegaethTestnet config
const megaethTestnetConfig = {
    id: 6342,
    name: 'MegaETH Testnet',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://carrot.megaeth.com/rpc'],
            webSocket: [],
        },
        public: {
            http: ['https://carrot.megaeth.com/rpc'],
            webSocket: [],
        },
    },
    blockExplorers: {
        default: { name: 'MegaETH Explorer', url: 'https://www.megaexplorer.xyz/' },
    },
} as const satisfies Chain

// Use defineViemChain instead of importing directly from wagmi/chains
const wagmiMegaethTestnet = defineViemChain(megaethTestnetConfig)

// Define Bitcoin chain
const bitcoinConfig = {
    id: 8332,
    name: 'Bitcoin',
    nativeCurrency: {
        name: 'Bitcoin',
        symbol: 'BTC',
        decimals: 8,
    },
    // Empty RPC URLs to satisfy type system - not used since Bitcoin uses Feather flow
    rpcUrls: {
        default: { http: [] },
        public: { http: [] },
    },
    blockExplorers: {
        default: { name: 'Blockchain.com', url: 'https://www.blockchain.com/explorer/blocks/btc' },
    },
} as const satisfies Chain

const wagmiBitcoin = defineViemChain(bitcoinConfig)

// Single export statement for all custom chains
export { wagmiUnichain, wagmiMegaethTestnet, wagmiBitcoin }
